// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"76a1bcc6","37":"5b789662","956":"379597a6"}[chunkId] + ".chunk.js";
};